import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import {
  BASKET_MODAL_REF,
  BasketPopupComponent,
} from '../../containers/basket/basket-popup/basket-popup.component';
import { BasketItemsService } from '../../containers/basket/services/basketItems.service';
import {
  LOGIN_MODAL_REF,
  LoginPopupComponent,
} from '../../core/authentication/login-popup/login-popup.component';
import { AuthService, User } from '../../services/auth/auth.service';
import { ModalService } from '../../services/modal.service';
import { START_STORY_URL } from '../site-links';

@Component({
  selector: 'app-site-header',
  standalone: true,
  imports: [AsyncPipe, RouterLink, TranslateModule],
  templateUrl: './site-header.component.html',
})
export class SiteHeaderComponent {
  @Input() showCta = true;

  readonly startStoryUrl = START_STORY_URL;
  readonly user$: Observable<User | null>;

  constructor(
    private readonly authService: AuthService,
    private readonly basketItemsService: BasketItemsService,
    private readonly modalService: ModalService,
  ) {
    this.user$ = this.authService.user$;
  }

  get count() {
    return this.basketItemsService.length;
  }

  openBasket() {
    this.modalService.openModal<BasketPopupComponent>(BasketPopupComponent, BASKET_MODAL_REF);
  }

  login() {
    this.modalService.openModal<LoginPopupComponent>(LoginPopupComponent, LOGIN_MODAL_REF);
  }

  logout() {
    this.authService.logout().subscribe(() => location.reload());
  }
}
